// Run this example by adding <%= javascript_pack_tag 'schedule_block' %> to the head of your layout file

import React from "react"
import ReactDOM from "react-dom"

import ScheduleBlock from "../schedule_block/ScheduleBlock"

const root = document.getElementById("schedule-block")

if (root) {
  const ids = root.dataset.ids
  const festival = root.dataset.festival
  const heading = root.dataset.heading
  const rowTitle = root.dataset.rowtitle

  document.addEventListener("DOMContentLoaded", () => {
    ReactDOM.render(
      <ScheduleBlock
        ids={ids}
        festival={festival}
        heading={heading}
        rowTitle={rowTitle}
      />,
      root,
    )
  })
}
